import {useContext} from 'react'

import Context from '@s-ui/react-context'

const BENEFIT_IMAGE = {
  width: 63,
  height: 51
}

const PanelBenefits = () => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const appName = config.get('APP_NAME').toLowerCase()
  const urlStaticImages = config.get('URL_STATICS_IMAGES')
  const urlInstantOfferImages = `${urlStaticImages}${appName}/landing/instant-offer/`

  const knowTheMarketPriceTitle = i18n.t('LANDING_VEHICLE_APPRAISER.BENEFITS.KNOW_THE_MARKET_PRICE.TITLE')
  const getInformedToNegotiateTitle = i18n.t('LANDING_VEHICLE_APPRAISER.BENEFITS.GET_INFORMED_TO_NEGOTIATE.TITLE')
  const instantAndFreeTitle = i18n.t('LANDING_VEHICLE_APPRAISER.BENEFITS.INSTANT_AND_FREE.TITLE')

  const benefits = [
    {
      description: i18n.t('LANDING_VEHICLE_APPRAISER.BENEFITS.INSTANT_AND_FREE.DESCRIPTION'),
      image: {
        alt: knowTheMarketPriceTitle,
        src: `${urlInstantOfferImages}bump.svg`
      }
    },

    {
      description: i18n.t('LANDING_VEHICLE_APPRAISER.BENEFITS.KNOW_THE_MARKET_PRICE.DESCRIPTION'),
      image: {
        alt: instantAndFreeTitle,
        src: `${urlInstantOfferImages}pricetag.svg`
      }
    },
    {
      description: i18n.t('LANDING_VEHICLE_APPRAISER.BENEFITS.GET_INFORMED_TO_NEGOTIATE.DESCRIPTION'),
      image: {
        alt: getInformedToNegotiateTitle,
        src: `${urlInstantOfferImages}handshake-v2.svg`
      }
    }
  ]

  return (
    <div className="mt-VehicleAppraiserPage-panelBenefits">
      {benefits &&
        benefits.map(benefit => (
          <div className="mt-VehicleAppraiserPage-panelBenefitsItem" key={benefit.title}>
            <img
              src={benefit.image.src}
              alt={benefit.image.alt}
              width={BENEFIT_IMAGE.width}
              height={BENEFIT_IMAGE.height}
            />
            <p>{benefit.description}</p>
          </div>
        ))}
    </div>
  )
}

PanelBenefits.displayName = 'PanelBenefits'

export default PanelBenefits
